<script lang="ts">
export default {
    name: 'IconCommunitySolar',
    props: {
        /**
         * Width
         */
        width: {
            type: String,
            default: '32px',
            required: false,
        },
        /**
         * Height
         */
        height: {
            type: String,
            default: '32px',
            required: false,
        },
    },
};
</script>

<template>
    <svg
        :style="{
            height: height,
            width: width,
        }"
        viewBox="0 0 32 32"
        fill="currentColor"
        xmlns="http://www.w3.org/2000/svg">
        <path
            d="M31.99 6.07a.96.96 0 0 0-.154-.68.936.936 0 0 0-.788-.39H7.871c-.532 0-1.077.37-1.305.881L4.56 10.45 2.24 15.73.107 20.595c-.155.35-.142.713.04.99a.922.922 0 0 0 .787.403h5.228v4.265a.571.571 0 1 0 1.144 0v-4.265h13.018v4.265a.571.571 0 1 0 1.144 0v-4.265h3.673c.62 0 1.252-.471 1.48-1.09l1.723-4.736 1.917-5.282.592-1.621v16.994a.571.571 0 1 0 1.144 0V6.117s-.007-.034-.007-.047Zm-7.67 1.056-1.143 2.987h-4.925l1.594-3.97h4.851l-.377.983Zm-5.247 13.725h-5.127l1.73-4.313h5.045l-.787 2.06-.861 2.253ZM17.02 10.12h-4.912l1.669-3.97h4.837l-1.594 3.97Zm-5.396 1.144h4.938L14.901 15.4H9.89l1.736-4.137Zm9.533 4.137h-5.025l1.661-4.137h4.945l-.881 2.314-.7 1.823ZM7.615 6.346c.047-.108.202-.202.256-.202h4.662l-1.668 3.97H5.96l1.655-3.768Zm-2.16 4.91h4.932l-1.736 4.139H3.64l1.816-4.138Zm-2.32 5.282H8.16l-1.783 4.246-.027.06H1.244l1.89-4.312v.006Zm6.243.06.027-.06h5.039l-1.73 4.313h-5.12l1.784-4.245v-.007Zm16.174 3.91c-.068.195-.296.336-.404.336h-4.85l.786-2.059.861-2.253h5.053l-1.446 3.97v.006Zm1.863-5.113h-5.032l.881-2.315.7-1.823h4.952l-1.507 4.138h.006Zm1.918-5.282H24.4l.377-.982 1.144-2.987h4.857l-1.446 3.97Z" />
    </svg>
</template>
